module.exports = __webpack_public_path__ + "img/11.e3fb0caa.png";